"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.capitalize=capitalize;exports.clamp=clamp;/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */function capitalize(str){return str.charAt(0).toUpperCase()+str.substr(1);}/**
 * Clamp position between a range
 * @param  {number} - Value to be clamped
 * @param  {number} - Minimum value in range
 * @param  {number} - Maximum value in range
 * @return {number} - Clamped value
 */function clamp(value,min,max){return Math.min(Math.max(value,min),max);}